import styled from 'styled-components';

export const StyledSuggestionFieldRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledSuggestionSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
